import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import LiftOffHeader from "./liftOffHeader";
import Select from "react-select";
import GalaxyTab from "./galaxyTab/galaxyTab";
import StandardHierarchyTab from "./standardHierarchyTab/standardHierarchyTab";
import {
  getGradeAll,
  getStateAll,
  postSubjectAPI,
  updateSubjectAPI,
  getSubjectAPI,
  IUpdateSubjectRequest,
} from "../../../api/subject.service";
import Loader from "../../shared/loader/loader";
import {
  ISubjectDTO,
  ILiftOffHeader,
  IKeyValue,
} from "../../../model/interface/subject";
import { IDropDown } from "../../../model/shared/dropDown";
import constant from "../../../utils/constant";
import { getContentArea } from "../../../api/contentArea.service";
import MultiSelect from "../../shared/common/multiSelect";
import { Link, useNavigate } from "react-router";
import { toast } from "react-toastify";
import AllowedTo from "../../shared/common/rbac";
import Permissions from "../../../utils/permissions";
import AccessDenied from "../../shared/common/accessDenied";
import { useNumericParam } from "../../../utils/useNumericParam";

const LiftOffSubject: React.FC = (props: any) => {
  const defaultHeader: ILiftOffHeader = {
    liftOffHeaderId: 0,
    subjectId: 0,
    header: "",
    isActive: false,
    createdByUserId: 1,
    updatedByUserId: 1,
  };
  const defaultContent: IDropDown = {
    value: 0,
    label: "",
  };
  const defaultCalculatorType = 1;
  const totalHeaders = 6;
  const defaultPageNumber = 1;
  const subjectTypeId = 2;
  const tab = { GalaxyTab: 0, StandardHierarchyTab: 1 };

  const navigate = useNavigate();
  const id = useNumericParam("id");
  const [isValidFlag, setIsValidFlag] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(tab.GalaxyTab);
  const [editFlag, setEditFlag] = useState(false);
  const [grades, setGrades] = useState<Array<IDropDown>>([]);
  const [contents, setContents] = useState<Array<IDropDown>>([]);
  const [states, setStates] = useState<Array<IDropDown>>([]);
  const [subjectName, setSubjectName] = useState("");
  const [isApproved, setIsApproved] = useState(false);
  const [isNWEASubject, setIsNWEASubject] = useState(false);
  const [noOfHeaders, setNoOfHeaders] = useState(0);
  const [selectedGrades, setSelectedGrades] = useState<Array<IDropDown>>([]);
  const [selectedStates, setSelectedStates] = useState<Array<IDropDown>>([]);
  const [selectedContent, setSelectedContent] = useState(defaultContent);
  const [selectedLiftOffHeader, setSelectedLiftOffHeader] =
    useState<ILiftOffHeader>(defaultHeader);
  const [liftOffHeaders, setLiftOffHeaders] = useState<Array<ILiftOffHeader>>(
    []
  );

  useEffect(() => {
    getGrades();
    getStates();
    getContent();
    setEditFlag(id ? true : false);
    if (id && id > 0) {
      getLiftOffSubjectData();
    }
  }, []);

  const getMappedArray = (arr: any[]) => {
    if (arr === null || arr.length === 0) {
      return [];
    } else {
      return arr.reduce((acc: any, cur: any) => {
        acc.push({ id: cur.value, name: cur.label });
        return acc;
      }, []);
    }
  };

  const getGrades = async () => {
    const response = getGradeAll(100, defaultPageNumber);
    const data = (await response).data;
    let dropdownData = [];
    if (data.data.length > 0) {
      data.data.sort(
        (firstItem, secondItem) => firstItem.gradeId - secondItem.gradeId
      );
      dropdownData = data.data.map((eachGradeData) => {
        return {
          value: eachGradeData.gradeId || 0,
          label: `${eachGradeData.name}`,
        };
      });
    }
    setGrades(dropdownData);
  };

  const getStates = async () => {
    const response = getStateAll(999, defaultPageNumber);
    const data = (await response).data;
    let newStateData = [];
    if (data.data.length > 0) {
      newStateData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.stateId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setStates(newStateData);
  };

  const getContent = async () => {
    const response = getContentArea(999, defaultPageNumber);
    const data = (await response).data;

    let newContentData = [];
    if (data.data.length > 0) {
      newContentData = data.data.map((eachContentData) => {
        return {
          value: eachContentData.contentAreaId || 0,
          label: `${eachContentData.name}`,
        };
      });
    }
    setContents(newContentData);
  };

  const getLiftOffSubjectData = () => {
    setLoading(true);
    getSubjectAPI(id).then((r) => {
      setLoading(false);
      bindData(r.data);
    });
  };

  const bindData = (data: ISubjectDTO) => {
    bindLFSubject(data);
    bindLFHeader(data.liftOffHeaders ? data.liftOffHeaders : []);
    bindContent(data);
    bindLFGrade(data.grades);
    bindLFState(data.states);
  };

  const bindLFSubject = (data: ISubjectDTO) => {
    const name = data.name;
    const status = data.isApproved;
    const isNwea = data.isNWEASubject;
    const NumberOfHeader = data.liftOffHeaders ? data.liftOffHeaders.length : 0;
    setSubjectName(name);
    setIsApproved(status ? true : false);
    setIsNWEASubject(isNwea ? true : false);
    setNoOfHeaders(NumberOfHeader);
  };

  const bindLFHeader = (data: Array<ILiftOffHeader>) => {
    if (data.length > 0) {
      setSelectedLiftOffHeader(data[0]);
    }

    setLiftOffHeaders(data);
  };

  const bindLFGrade = (data: Array<IKeyValue>) => {
    const activeGrades = data?.map((grade) => {
      return {
        value: grade.id,
        label: grade.name,
      };
    });

    setSelectedGrades(activeGrades);
  };

  const bindLFState = (data: Array<IKeyValue>) => {
    const activeStates = data?.map((state) => {
      return {
        value: state.id,
        label: state.name,
      };
    });

    setSelectedStates(activeStates);
  };

  const bindContent = (data: ISubjectDTO) => {
    const value = data.contentAreaId || 0;
    const label = data.contentAreaName || "";
    const content: IDropDown = {
      value: value,
      label: label,
    };

    setSelectedContent(content);
  };

  const handleSubjectNameChange = (name: string) => {
    setSubjectName(name);
  };

  const handleIsApprovedChange = (status: boolean) => {
    setIsApproved(status);
  };

  const handleIsNWEASubjectChange = (status: boolean) => {
    setIsNWEASubject(status);
  };

  const handleNoOfHeadersChange = (noOfHeaders: number) => {
    if (!editFlag) {
      setNoOfHeaders(noOfHeaders);

      const headers: Array<ILiftOffHeader> = [];

      [...Array(noOfHeaders)].map((item, index) => {
        const liftOffHeader: ILiftOffHeader = {
          liftOffHeaderId: 0,
          subjectId: 0,
          header: "Header " + (index + 1),
          isActive: true,
          createdByUserId: props.profile?.userId,
          updatedByUserId: props.profile?.userId,
        };
        headers.push(liftOffHeader);
      });

      setLiftOffHeaders(headers);
    }
  };

  const handleGradeChange = (selectedGrades: any) => {
    setSelectedGrades(selectedGrades);
  };

  const handleStateChange = (selectedStates: any) => {
    setSelectedStates(selectedStates);
  };

  const handleContentChange = (selectedContent: any) => {
    setSelectedContent(selectedContent);
  };

  const handleHeaderChange = (header: ILiftOffHeader) => {
    setSelectedLiftOffHeader(header);
  };

  const handleHeaderNameChange = (header: ILiftOffHeader) => {
    setSelectedLiftOffHeader(header);
    const headers = liftOffHeaders.map((lfHeader) => {
      if (lfHeader.liftOffHeaderId === header.liftOffHeaderId) {
        return header;
      }
      return lfHeader;
    });

    setLiftOffHeaders(headers);
  };

  const validateSubject = (subject: IUpdateSubjectRequest) => {
    let isValid = true;

    if (subject.name === "") {
      isValid = false;
    } else if (!subject.liftOffHeaders?.length) {
      isValid = false;
    } else if (subject.contentAreaId === 0) {
      isValid = false;
    } else if (subject.grades.length === 0) {
      isValid = false;
    } else if (subject.states.length === 0) {
      isValid = false;
    }

    setIsValidFlag(isValid);
    return isValid;
  };

  const handleAddEditSubject = () => {
    const subjectData: IUpdateSubjectRequest = {
      subjectId: editFlag ? id ?? 0 : 0,
      name: subjectName,
      notes: "",
      contentAreaId: selectedContent.value,
      states: getMappedArray(selectedStates),
      grades: getMappedArray(selectedGrades),
      liftOffHeaders: liftOffHeaders,
      isApproved: isApproved,
      isNWEASubject: isNWEASubject,
      subjectTypeId: subjectTypeId,
      calculatorTypeId: defaultCalculatorType,
    };

    if (validateSubject(subjectData)) {
      setLoading(true);
      if (editFlag) {
        updateSubjectAPI(subjectData)
          .then((r) => {
            setLoading(false);
            toast.success("Subject updated successfully");
          })
          .catch((r) => {
            setLoading(false);
            toast.error("Something went wrong!");
          });
      } else {
        postSubjectAPI(subjectData)
          .then((r) => {
            setLoading(false);
            toast.success("Subject Added Successfully");
            setTimeout(() => {
              navigate(
                constant.SUBJECTDETAIL.replace(":id", r.data.toString()),
                {
                  state: { subjectType: 2 },
                }
              );
            }, 1500);
          })
          .catch((r) => {
            setLoading(false);
            toast.error("Something went wrong!");
          });
      }
    }
  };

  const handleTabSelection = (tab: number) => {
    setSelectedTab(tab);
  };

  return (
    <AllowedTo
      perform={[Permissions.subject_create, Permissions.subject_modify]}
      no={() => <AccessDenied />}
    >
      {loading && <Loader></Loader>}
      <div
        className={`${
          editFlag ? "grid grid-cols-12 gap-10 mb-8" : "w-2/5 mr-14"
        }`}
      >
        <div className="col-span-4">
          <div className="shadow py-6 border rounded-lg mt-4 px-6">
            <div className="m-auto flex flex-col gap-3">
              <div className="flex gap-2 flex-col">
                <div className=" text-sm col-span-2 text-gray-700"> Name</div>
                <div className="mt-0 relative col-span-5">
                  <div className="col-span-2">
                    <input
                      id="name"
                      name="name"
                      type="text"
                      autoComplete="off"
                      className="w-full mt-1 order border-gray-300 rounded-md shadow-sm py-2 px-4 focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm"
                      value={subjectName}
                      onChange={(e) => {
                        handleSubjectNameChange(e.target.value);
                      }}
                    />
                    {subjectName === "" && !isValidFlag && (
                      <span className="text-red-700 inline-block pt-1 text-sm">
                        Name is required
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="flex gap-2 flex-col mt-2">
                <div className="flex gap-2 flex-col mt-2">
                  <div className=" text-sm col-span-2  text-gray-700">
                    Headers
                  </div>
                  <div className="flex gap-2">
                    {[...Array(totalHeaders)].map((item, index) => (
                      <button
                        key={index}
                        className={`flex items-center gap-1 py-2 px-3 mt-3 text-xs bg-transparent  border border-gray-300 transition ease-in-out duration-300 ${
                          noOfHeaders === index + 1
                            ? "bg-primary-color text-white"
                            : "text-primary-color text-gray-700"
                        }
                          ${
                            editFlag
                              ? "opacity-50"
                              : "hover:bg-secondary-color hover:text-white"
                          }`}
                        onClick={() => {
                          handleNoOfHeadersChange(index + 1);
                        }}
                      >
                        <span>{index + 1}</span>
                      </button>
                    ))}
                  </div>
                </div>
                <fieldset className="flex h-full justify-center items-center mt-3">
                  <legend className="sr-only">Privacy setting</legend>
                  <div className="bg-white rounded-md -space-y-px w-full">
                    {liftOffHeaders.map((header, index) => (
                      <LiftOffHeader
                        key={index}
                        {...header}
                        index={index}
                        isSelected={
                          editFlag
                            ? header.liftOffHeaderId ===
                              selectedLiftOffHeader.liftOffHeaderId
                            : false
                        }
                        isEnabled={editFlag}
                        handleHeaderChange={handleHeaderChange}
                      />
                    ))}

                    {liftOffHeaders.length === 0 && !isValidFlag && (
                      <span className="text-red-700 inline-block pt-1 text-sm">
                        Header is required
                      </span>
                    )}
                  </div>
                </fieldset>
              </div>

              <div className="my-3">
                <hr />
              </div>

              <div className="col-span-2">
                <label className="text-sm text-gray-700">Content Area</label>
                <Select
                  className="mt-1 text-sm"
                  onChange={(e) => {
                    handleContentChange(e);
                  }}
                  value={selectedContent}
                  options={contents}
                  theme={(theme) => ({
                    ...theme,
                    colors: {
                      ...theme.colors,
                      primary25: "#B3B3B3",
                      primary: "#041E42",
                    },
                  })}
                />
                {selectedContent.value === 0 && !isValidFlag && (
                  <span className="text-red-700 inline-block pt-1 text-sm">
                    Content area is required
                  </span>
                )}
              </div>
              <div className="">
                <span className="text-gray-700">Grade</span>
                <div className="mt-2 flex flex-col gap-2">
                  <MultiSelect
                    options={grades}
                    selectedItems={selectedGrades}
                    setSelectedItems={setSelectedGrades}
                  />
                  {selectedGrades.length === 0 && !isValidFlag && (
                    <span className="text-red-700 inline-block pt-1 text-sm">
                      Grade is required
                    </span>
                  )}
                </div>
              </div>
              <div className="">
                <span className="text-gray-700">State</span>
                <div className="mt-2 flex flex-col gap-2">
                  <MultiSelect
                    options={states}
                    selectedItems={selectedStates}
                    setSelectedItems={setSelectedStates}
                  />
                  {selectedStates.length === 0 && !isValidFlag && (
                    <span className="text-red-700 inline-block pt-1 text-sm">
                      State is required
                    </span>
                  )}
                </div>
              </div>
              <div className="flex gap-10">
                <div className="flex mt-6">
                  <div>
                    <input
                      id="isNWEA"
                      name="isNWEA"
                      type="checkbox"
                      checked={isNWEASubject}
                      onChange={() => {
                        handleIsNWEASubjectChange(!isNWEASubject);
                      }}
                      className=" h-4 w-4 mr-2 focus:ring-primary-color text-primary-color  border-gray-300 rounded sm:text-sm border-gray-300 rounded"
                    />
                  </div>
                  <div className="text-sm flex items-center">
                    <label
                      className="font-medium text-gray-700"
                      htmlFor="isNWEA"
                    >
                      Is NWEA Subject
                    </label>
                  </div>
                </div>
                <div className="flex mt-6">
                  <div>
                    <input
                      id="isApproved"
                      name="isApproved"
                      type="checkbox"
                      checked={isApproved}
                      onChange={() => {
                        handleIsApprovedChange(!isApproved);
                      }}
                      className=" h-4 w-4 mr-2 focus:ring-primary-color text-primary-color  border-gray-300 rounded sm:text-sm border-gray-300 rounded"
                    />
                  </div>
                  <div className="text-sm flex items-center">
                    <label
                      className="font-medium text-gray-700"
                      htmlFor="isApproved"
                    >
                      Approved
                    </label>
                  </div>
                </div>
              </div>
              <div className="flex justify-end items-center pb-2 border-t mt-5">
                <button
                  type="submit"
                  className="inline-flex items-center px-3 py-2 my-3 border border-transparent text-sm leading-4 font-medium rounded-md shadow-sm text-white dark:text-white bg-primary-color hover:bg-secondary-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color"
                  onClick={() => {
                    handleAddEditSubject();
                  }}
                >
                  {editFlag ? "Save" : "Add"}
                </button>

                <Link to={constant.SUBJECTS} className="ml-2">
                  <button className="inline-flex items-center px-3 py-2 my-3 hover:text-gray-500 border border-gray-300 text-sm leading-4 font-medium rounded-md shadow-sm text-gray-700 bg-white  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color">
                    Cancel
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {editFlag && selectedLiftOffHeader.liftOffHeaderId > 0 && (
          <div className="col-span-8">
            <div className="flex items-center justify-between mb-8 mt-4">
              <div className="bg-gray-100 w-full">
                <button
                  className={` before:border-primary-color before:absolute before:w-full before:h-2 before:top-0 before:left-0 group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10
                    ${
                      selectedTab === tab.GalaxyTab
                        ? "text-gray-900 topBorder border border-b-0 bg-white before:border-t-2"
                        : "text-gray-500"
                    }
                    `}
                  type="button"
                  onClick={() => {
                    handleTabSelection(tab.GalaxyTab);
                  }}
                >
                  Galaxy
                </button>
                <button
                  className={` before:border-primary-color before:absolute before:w-full before:h-2 before:top-0 before:left-0 group relative min-w-0 flex-1 overflow-hidden py-4 px-4 text-sm font-medium text-center hover:bg-gray-50 focus:z-10
                    ${
                      selectedTab === tab.StandardHierarchyTab
                        ? "text-gray-900 topBorder border border-b-0 bg-white before:border-t-2"
                        : "text-gray-500"
                    }
                    `}
                  type="button"
                  onClick={() => {
                    handleTabSelection(tab.StandardHierarchyTab);
                  }}
                >
                  Standard Hierarchy
                </button>
              </div>
            </div>

            <div className="p-4 shadow -mt-8">
              {selectedTab === tab.GalaxyTab && (
                <GalaxyTab
                  {...selectedLiftOffHeader}
                  handleHeaderNameChange={handleHeaderNameChange}
                  selectedStates={selectedStates.map((item) => item.value)}
                  selectedGrades={selectedGrades.map((item) => item.value)}
                  selectedContentId={selectedContent.value}
                />
              )}
              {selectedTab === tab.StandardHierarchyTab && (
                <StandardHierarchyTab
                  {...selectedLiftOffHeader}
                ></StandardHierarchyTab>
              )}
            </div>
          </div>
        )}
      </div>
    </AllowedTo>
  );
};

const mapStateToProps = (state: any) => {
  return {
    profile: state.profile,
  };
};
export default connect(mapStateToProps, {})(LiftOffSubject);
